import { CButton, CCard, CCardBody, CCol, CForm, CInputGroup, CRow } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import BaseListing from 'src/BaseListings'
import { lzDownloadBlobFile, wtApiCall } from '../../helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications'
import DataReportTable from './DataReportTable'
import Loading from 'src/helpers/commons/loader'
import { DatePicker } from 'antd'
import moment from 'moment'
import WidgetDesignationSelector from 'src/widgets/Selectors/WidgetDesignationSelector'
import WidgetBranchSelector from 'src/widgets/Selectors/WidgetBranchSelector'
import {
  getExcelDateExportConfig,
  useMasterDateTimeFormats,
} from 'src/helpers/commons/masterDateFormat'
const { RangePicker } = DatePicker
export default function OvertimeReport() {
  const Base = new BaseListing()
  const { dateFormat, formatDate } = useMasterDateTimeFormats()
  const [isLoading, setIsLoading] = useState(false)
  const [reportData, setReportData] = useState([])
  const [range, setRange] = useState(null)
  const [branches, setBranches] = useState([])
  const [designations, setDesignations] = useState([])
  const [designation_id, setDesignationId] = useState(0)
  const [designation_name, setDesignationName] = useState('')
  const [branchId, setBranchId] = useState(0)
  const [branch_name, setBranchName] = useState('')

  const escapeExcelValue = (value) =>
    String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')

  const buildExcelDateCell = (value) => {
    const exportConfig = getExcelDateExportConfig(value, dateFormat)

    if (exportConfig.type === 'empty') {
      return '<td></td>'
    }

    if (exportConfig.type === 'str') {
      return `<td x:str>${escapeExcelValue(exportConfig.value)}</td>`
    }

    return `<td style="mso-number-format:'${exportConfig.numberFormat}';" x:num>${exportConfig.value}</td>`
  }

  const exportToExcel = () => {
    const rows = reportData
      .map(
        (item, index) => `
          <tr>
            <td>${escapeExcelValue(index + 1)}</td>
            <td>${escapeExcelValue(item.employee_id)}</td>
            <td>${escapeExcelValue(item.employee?.full_name)}</td>
            <td>${escapeExcelValue(item.employee?.designation?.name)}</td>
            <td>${escapeExcelValue(item.employee?.department?.name)}</td>
            <td>${escapeExcelValue(item.employee?.branch?.name)}</td>
            ${buildExcelDateCell(item.employee?.date_of_joining)}
            ${buildExcelDateCell(item.resignation_date)}
            <td>${escapeExcelValue(item.reason)}</td>
          </tr>`,
      )
      .join('')

    const excelHtml = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office"
        xmlns:x="urn:schemas-microsoft-com:office:excel"
        xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Leaving Report</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
          <style>
            table{border-collapse:collapse;width:100%;}
            td,th{border:1px solid #cfd8e3;padding:6px 8px;vertical-align:middle;}
            th{background:#1F4E78;color:#fff;font-weight:700;text-align:center;}
          </style>
        </head>
        <body>
          <table>
            <tr>
              <th>Sr No.</th>
              <th>ID</th>
              <th>Full Name</th>
              <th>Designation</th>
              <th>Department</th>
              <th>Branch</th>
              <th>Date Of Joining</th>
              <th>Date Of Leaving</th>
              <th>Reason</th>
            </tr>
            ${rows}
          </table>
        </body>
      </html>
    `

    const excelBlob = new Blob([excelHtml], {
      type: 'application/vnd.ms-excel;charset=utf-8;',
    })
    lzDownloadBlobFile(
      excelBlob,
      `Leaving_Report_${moment().format('YYYY_MM_DD_HH_mm_ss')}.xls`,
    )
  }

  const getReportData = () => {
    if (!range || range.length < 2) {
      lzNotifyErrorMessageFromResult("Please select a valid date range");
      return;
    }

    const fromDate = range[0];
    const toDate = range[1];
    setIsLoading(true);

    wtApiCall(
      'reports/leaving_report',
      {
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD'),
        branch_id: branchId,
        designation_id: designation_id,
      },
      'get',
      (response) => {
        setReportData(response.data);
        setIsLoading(false);
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error);
        setIsLoading(false);
      },
    );
  };

  const changeValues = (key, val) => {

    if (key === 'designation_id') {
      setDesignationId(val.value)
      setDesignationName(val.label)
    }

    if (key === 'branch_id') {
      setBranchId(val.value)
      setBranchName(val.label)
    }
  }

  useEffect(() => {
    Base.dropdownData(
      'branches,designations',
      {},
      [setBranches, setDesignations],
      1,
    )
  }, [])
  return (
    <>
      <div style={{ padding: '2%' }}>
        <center>
          <h4>Leaving Report</h4>
        </center>
        <CRow style={{ width: '100%' }}>
          <CCol md={12}>
            <CCard className="card-dark">
              <CCardBody style={{ backgroundColor: '#f7f9fa' }}>
                <br />
                <CForm>
                  <CRow>
                    {/* <CCol md={1}></CCol> */}
                    <CCol md={1}>
                      <CInputGroup>
                        <label style={{ fontSize: '140%', marginTop: '50px' }}>Filters:</label>
                      </CInputGroup>
                    </CCol>
                    <CCol md={2}>
                      <div className="form-group">
                        <label>Date Range:</label>
                        <br />
                        <RangePicker value={range} onChange={setRange} size="middle" />
                      </div>
                    </CCol>
                    <CCol md={2}>
                      <CInputGroup>
                        <label>Designation</label>
                        <WidgetDesignationSelector
                          designations={designations}
                          displayValue={designation_name}
                          value={designation_id}
                          placeholder="Select Designation"
                          onChange={(values) => changeValues('designation_id', values)}
                          reloadDropdownData={() =>
                            Base.dropdownData('designations', {}, [setDesignations], 1)
                          }
                        />
                       
                      </CInputGroup>
                    </CCol>

                    <CCol md={2}>
                      <CInputGroup>
                        <label>Branch</label>
                        <WidgetBranchSelector
                          branches={branches}
                          displayValue={branch_name}
                          value={branchId}
                          placeholder="Select Branch"
                          onChange={(values) => changeValues('branch_id', values)}
                          reloadDropdownData={() =>
                            Base.dropdownData('branches', {}, [setBranches], 1)
                          }
                        />
                      </CInputGroup>
                    </CCol>

                    <CCol md={4}>
                      <CButton
                        color="primary"
                        onClick={() => getReportData()}
                        style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                      >
                        Search
                      </CButton>
                      {Base.hasRights('Export Leaving Report') && (
                        <CButton
                          color="success"
                          onClick={exportToExcel}
                          style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                          className="text-white"
                          disabled={isLoading || reportData.length === 0}
                        >
                          Export
                        </CButton>
                      )}
                    </CCol>
                  </CRow>

                  <br />
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <br />
        <br />
        <CRow>
          <CCol md={12}>
            <table className="table table-bordered data-table">
              {isLoading ? (
                Loading
              ) : (
                <>
                  {reportData.length > 0 ? (
                    <DataReportTable
                      reportData={reportData}
                      setReportData={(data) => setReportData(data)}
                      isLoading={isLoading}
                      formatDate={formatDate}
                    />
                  ) : (
                    <tbody>
                      <tr
                        style={{
                          border: 0,
                          fontWeight: 'bold',
                          textAlign: 'center',
                          fontSize: '19px',
                        }}
                      >
                        <td>No record to show...</td>
                      </tr>
                    </tbody>
                  )}
                </>
              )}
            </table>
          </CCol>
        </CRow>
      </div>
    </>
  )
}
